import { Injectable } from '@angular/core';
import { init as FSInit, FullStory, isInitialized } from '@fullstory/browser';
import moment from 'moment-timezone';
import { CommonService } from './common.service';
import { CSharpRequestService } from './csharp-request.service';
import * as appApiResources from '../globalcontants';

@Injectable({ providedIn: 'root' })
export class FullStoryService {
  constructor(
    private commonService: CommonService,
    private csharpService: CSharpRequestService
  ) {}

  initSession(): void {
    try {
      if (!this.isEnabled() || !this.commonService.isonlineStatus) {
        return;
      }

      if (!isInitialized()) {
        FSInit(
          { orgId: 'SRKVD' },
          ({ sessionUrl }) => console.log(`FullStory session started: ${sessionUrl}`)
        );
      }

      const userInfoRaw = sessionStorage.getItem(appApiResources.userInfo);
      const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
      const userName: string = userInfo?.UserName || '';
      const email: string = userInfo?.EmailId || userInfo?.Email || '';
      const tenant: string = localStorage.getItem('tenant') || '';

      FullStory('setIdentity', {
        uid: userName,
        properties: {
          displayName: userName,
          email,
          Name: userName,
          TenantName: tenant,
          AppType: 'Mobile'
        }
      });
      FullStory('log', { level: 'log', msg: 'User logged Successfully' });

      this.csharpService.RequestGETCSharp(
        appApiResources.cSharpURLs.LoaderStop,
        {
          componentName: appApiResources.ComponentNameReferences.Login,
          funcName: appApiResources.CSharpCallBackFunctions.LoaderStopCallBack,
          Action: appApiResources.cSharpActionName.LoaderStop
        },
        false
      );
    } catch (error) {
      console.error('FullStory init error:', error);
    }
  }

  setPage(pageName: string): void {
    try {
      if (this.commonService.isonlineStatus && this.isEnabled() && isInitialized()) {
        FullStory('setProperties', {
          type: 'page',
          properties: {
            pageName,
            page_used_date: moment().format('YYYY-MM-DD'),
            page_used_time: moment().format('HH:mm:ss')
          }
        });
      }
    } catch (fsError) {
      console.error('FullStory setPage error:', fsError);
    }
  }

  trackEvent(eventName: string, properties: { [key: string]: any } = {}): void {
    try {
      if (this.commonService.isonlineStatus && this.isEnabled() && isInitialized()) {
        FullStory('trackEvent', { name: eventName, properties });
      }
    } catch (fsError) {
      console.error('FullStory trackEvent error:', fsError);
    }
  }

  shutdown(): void {
    try {
      if (isInitialized()) {
        FullStory('shutdown');
      }
    } catch (fsError) {
      console.error('FullStory shutdown error:', fsError);
    }
  }

  private isEnabled(): boolean {
    return localStorage.getItem('EnableFullStoryMobile')?.toLowerCase() === 'true';
  }
}
